import BillLading from '@/components/BillLading/BillLading';
import pdf from 'vue-pdf'
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'
export default {
    name: "PlatformBillInvalidAudit",
	conditionData:'',
	mounted: function () {
      this.init();
	},
	components:{
        BillLading,
        pdf
	},
    data() {
        return {
            showBillLading: false,
            showPdf: true,
            billLadingData: {},
            pdfSrc: '',
            numPages: 0,
            progress: 0,
            progressShow: true,
            opinion: '',
            data: {},
            destructionIsPreview: false,
            destructionTitle: this.$t('p_billInvalidAudit.destructionTitle'),
            destructionImage: null,
            guaranteeIsPreview: false,
            guaranteeTitle: this.$t('p_billInvalidAudit.destructionTitle'),
            guaranteeImage: null
        }
    },
    watch: {
        'data.destruction'() {
            this.data.destruction = this.data.destruction.substring(this.data.destruction.lastIndexOf('/') + 1);
        },
        'data.guarantee'() {
            this.data.guarantee = this.data.guarantee.substring(this.data.guarantee.lastIndexOf('/') + 1);
        },
    },
    methods: {
        init(){
			// 取数据判断是走表单，还是PDF.修改showBillLading和showPdf(互斥)
			this.conditionData = this.$routerUtil.getParam();
            this.data = this.conditionData.row;
            if (this.data.billSignatureFiles) {
                this.data.billSignatureFiles.forEach(file => {
                    if (file.type === 1) {
                        this.pdfSrc = pdf.createLoadingTask({url: '/api' + file.file, CMapReaderFactory});
                    }
                });
            }
            this.data.invalidFileIds = [];
            this.data.applyFileRefVos.forEach(item => {
                this.data.invalidFileIds.push(item.fileId);
            });
            this.pdfSrc.onProgress = progress => {
                let tempProgress = progress.loaded / progress.total * 100;
                if(tempProgress > 100){
                    tempProgress = 100;
                }
                this.progress = tempProgress;
                if (this.progress === 100) {
                    setTimeout(() => {
                        this.progressShow = false;
                        for(const key in require.cache) {
                            if(require && require.cache && require.cache[key] && require.cache[key].exports && require.cache[key].exports.default instanceof Uint8Array){
                                console.log(key);
                                delete require.cache[key];
                            }
                        }
                    }, 500);
                }
            };
            this.loadPdfHandler();
		},
		doBack(){
			this.$routerUtil.setParam(this.conditionData.searchForm);
			this.$router.push('bill-invalid-apply-manage');
		},
        doConfirm(result) {
            const param = {};
            param.id = this.data.applyId;
            param.version = this.data.version;
            param.platformAuditResult = result;
            param.platformAuditOpinion = this.opinion;
            param.type = this.data.type;
            param.applyUserAccount = this.data.applyUserAccount;
            param.applyUserName = this.data.applyUserName;
            param.blNo = this.data.blNo;
            this.$axios.put('/api/billOfLadings/voidBillOfLading', param).then(response => {
                if (response.data.status === '1') {
                    this.doBack();
                    this.$message({
                        // message: this.$t('c_billInvalid.invalidAuditSuccessMassage'),
                        message: this.$t(response.data.message),
                        type: 'success',
                        center: true
                    });
                }else{
                    this.$message({
                        message: this.$t(response.data.message),
                        type: 'error',
                        center: true
                    });
                }
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        loadPdfHandler() {
            this.pdfSrc.promise.then(pdf => {
                this.numPages = pdf.numPages;
            });
        },
        // 销毁记录预览
        destructionPreview(destruction) {
            this.destructionIsPreview = true;
            this.destructionImage = "/api/file/" + destruction;
        },
        // 报废保函预览
        guaranteePreview(guarantee) {
            this.guaranteeIsPreview = true;
            this.guaranteeImage = "/api/file/" + guarantee;
        },
    }
}
